"use client";

import "./styles.scss";
import ClipArtManagement from "@/components/library/ClipArtManagement";
import FontManagement from "@/components/library/FontManagement";
import AIFilterManagement from "@/components/library/AIFilterManagement";
import { useRouter, useSearchParams } from "next/navigation";
import { TabView, TabPanel } from "primereact/tabview";

enum LibraryType {
  clipArt = "clip-art",
  font = "font",
  aiFilter = "ai-filter",
}

const tabTypes: { [index: number]: LibraryType } = {
  0: LibraryType.clipArt,
  1: LibraryType.font,
  2: LibraryType.aiFilter,
};

const tabIndexes = {
  [LibraryType.clipArt]: 0,
  [LibraryType.font]: 1,
  [LibraryType.aiFilter]: 2,
};

const LibrariesPage = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const type = searchParams.get("type") || LibraryType.clipArt;

  const activeIndex =
    tabIndexes[type as LibraryType] ?? tabIndexes[LibraryType.clipArt];

  const onTabChange = (index: number) => {
    const tabType = tabTypes[index];
    if (!tabType) return;
    const params = new URLSearchParams(searchParams.toString());
    params.set("type", tabType);
    router.push(`?${params.toString()}`);
  };

  return (
    <div className="flex h-full w-full flex-col p-4">
      <h1 className="text-xl font-bold text-gray-800">Libraries</h1>
      <div className="flex flex-1 flex-col overflow-auto">
        <TabView
          className="tab-view flex h-full flex-1 flex-col"
          activeIndex={activeIndex}
          onTabChange={(event) => onTabChange(event.index)}
        >
          <TabPanel header="Clip arts">
            <div className="flex h-full w-full overflow-auto">
              <ClipArtManagement />
            </div>
          </TabPanel>
          <TabPanel header="Fonts">
            <div className="flex h-full w-full overflow-auto">
              <FontManagement />
            </div>
          </TabPanel>
          <TabPanel header="AI Filters">
            <div className="flex h-full w-full overflow-auto">
              <AIFilterManagement />
            </div>
          </TabPanel>
        </TabView>
      </div>
    </div>
  );
};

export default LibrariesPage;
